export default __webpack_public_path__ + "static/145-4d404ce95e22dc93b8bbba335de6e324.gif";